const LARGO_CUIT = 11

/**
 * Deja el CUIT en los 11 dígitos que espera el backend.
 * `POST /v1/login/contrato` valida `/^\d+$/` y longitud exacta, así que
 * cualquier CUIT formateado tiene que pasar por acá antes de viajar.
 *
 * @param {string|number} cuit
 * @returns {string} sólo dígitos
 */
export function normalizarCuit(cuit) {
  return String(cuit ?? '').replace(/\D/g, '')
}

/**
 * Formatea el CUIT como XX-XXXXXXXX-X para mostrarlo en la grilla.
 * Si no tiene 11 dígitos devuelve el valor original: preferimos mostrar
 * el dato crudo antes que esconderlo detrás de un formato que no aplica.
 *
 * @param {string|number} cuit
 * @returns {string}
 */
export function formatearCuit(cuit) {
  const digitos = normalizarCuit(cuit)

  if (digitos.length !== LARGO_CUIT) {
    return String(cuit ?? '')
  }

  return `${digitos.slice(0, 2)}-${digitos.slice(2, 10)}-${digitos.slice(10)}`
}

/**
 * @param {string|number} cuit
 * @returns {boolean} true si tiene los 11 dígitos que exige el backend
 */
export function esCuitValido(cuit) {
  return normalizarCuit(cuit).length === LARGO_CUIT
}
